export const colors = {
  green: '#09383a',
  orange: '#f96d30',
  white: '#f4f0ed',
}
